import { render, staticRenderFns } from "./HighlightItemSection.vue?vue&type=template&id=179d32f5&scoped=true"
import script from "./HighlightItemSection.vue?vue&type=script&lang=ts"
export * from "./HighlightItemSection.vue?vue&type=script&lang=ts"
import style0 from "./HighlightItemSection.vue?vue&type=style&index=0&id=179d32f5&prod&lang=scss&scoped=true"
import style1 from "./HighlightItemSection.vue?vue&type=style&index=1&id=179d32f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d32f5",
  null
  
)

export default component.exports